//@ts-check
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useMemo} from 'react'
import {useCategoryList} from '../useCategoryList'

export const useSelectComboCategories = () => {
  const {categoryListData} = useCategoryList('displayCategory')

  const {updateProductCombo, productCombo} = useProductCombo()

  const categoriesOptions = useMemo(
    () =>
      categoryListData?.map(category => {
        const {id, ...categoryData} = category

        return {
          id,
          displayText: category.en,
          categoryData,
        }
      }) ?? [],
    [categoryListData]
  )

  const categoriesOptionsById = useMemo(
    () => new Map(categoriesOptions.map(option => [option.id, option])),
    [categoriesOptions]
  )

  const handleCategoryChange = values => {
    const selectedCategories = (values || []).reduce(
      (accumulator, value) => {
        accumulator.displayCategoryIds.push(value.id)
        accumulator.displayCategories.push(value.categoryData)

        return accumulator
      },
      {
        displayCategoryIds: [],
        displayCategories: [],
      }
    )

    updateProductCombo({
      displayCategoryIds: selectedCategories.displayCategoryIds,
      displayCategories: selectedCategories.displayCategories,
    })
  }

  const selectedCategories = useMemo(
    () =>
      (productCombo.displayCategoryIds || []).map(categoryId => categoriesOptionsById.get(categoryId)).filter(Boolean),
    [categoriesOptionsById, productCombo.displayCategoryIds]
  )

  const handleIgnoreSkuListToggle = value => {
    updateProductCombo({
      ignoreSkuList: value,
    })
  }

  return {
    categoriesOptions,
    handleCategoryChange,
    selectedCategories,
    handleIgnoreSkuListToggle,
    ignoreSkuList: productCombo.ignoreSkuList,
  }
}
